import { createSelector } from '@reduxjs/toolkit';

// Base selector
export const selectAuthActivity = (state) => state.authActivity;

// SSE selectors
export const selectSseData = (state) => state.authActivity.sseData;

// Memoized selector for paginated SSE events
export const selectPaginatedSseEvents = createSelector(
  [selectSseData],
  (sseData) => {
    const { events, currentPage, pageSize } = sseData;
    const startIndex = (currentPage - 1) * pageSize;
    return events.slice(startIndex, startIndex + pageSize);
  }
);

// Memoized selector for SSE pagination info
export const selectSsePaginationInfo = createSelector(
  [selectSseData],
  (sseData) => {
    const { events, currentPage, pageSize } = sseData;
    return {
      page: currentPage,
      totalPages: Math.ceil(events.length / pageSize),
      totalCount: events.length,
      pageSize,
    };
  }
);

// Adapid selectors
export const selectAdapidData = (state) => state.authActivity.adapidActivities;

// Memoized selector for paginated Adapid data
export const selectPaginatedAdapidData = createSelector(
  [selectAuthActivity],
  (authActivity) => {
    const { adapidActivities, currentPage, pageSize } = authActivity;
    const startIndex = (currentPage - 1) * pageSize;
    return adapidActivities.data?.slice(startIndex, startIndex + pageSize) ?? [];
  }
);

// Memoized selector for Adapid pagination info
export const selectAdapidPaginationInfo = createSelector(
  [selectAuthActivity],
  (authActivity) => {
    const { adapidActivities, currentPage, pageSize } = authActivity;
    return {
      page: currentPage,
      totalPages: Math.ceil((adapidActivities.data?.length ?? 0) / pageSize),
      totalCount: adapidActivities.data?.length ?? 0,
      pageSize,
    };
  }
);